import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test001',
  templateUrl: './test001.component.html',
  styleUrls: ['./test001.component.css']
})
export class Test001Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
